import { render, staticRenderFns } from "./BzMetaboProject.vue?vue&type=template&id=50723829"
import script from "./BzMetaboProject.vue?vue&type=script&lang=js"
export * from "./BzMetaboProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports